var map = {
	"./de": 4700,
	"./de.json": 4700,
	"./en": 4701,
	"./en-GB": 4702,
	"./en-GB.json": 4702,
	"./en.json": 4701,
	"./es": 4703,
	"./es.json": 4703,
	"./fr": 4704,
	"./fr.json": 4704,
	"./he": 4705,
	"./he.json": 4705,
	"./it": 4706,
	"./it.json": 4706,
	"./ja": 4707,
	"./ja.json": 4707,
	"./ko": 4708,
	"./ko.json": 4708,
	"./nl": 4709,
	"./nl.json": 4709,
	"./pt": 4710,
	"./pt.json": 4710,
	"./ru": 4711,
	"./ru.json": 4711,
	"./vi": 4712,
	"./vi.json": 4712,
	"./zh-Hans": 4713,
	"./zh-Hans.json": 4713,
	"./zh-Hant": 4714,
	"./zh-Hant-TW": 4715,
	"./zh-Hant-TW.json": 4715,
	"./zh-Hant.json": 4714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4887;